import {ChronologicalCommentsSort, useChronologicalCommentsSort} from '@github-ui/commenting/useCommentsSortPreference'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useCallback} from 'react'

/** Always oldest first when the Activity tab is off. */
export function useIssueCommentsSort() {
  const [savedSort, setSavedSort] = useChronologicalCommentsSort()
  const enabled = isFeatureEnabled('issue_viewer_activity_tab')

  const setSort = useCallback(
    (next: ChronologicalCommentsSort) => {
      // Picking the current sort again isn't a change.
      if (next === savedSort) return
      setSavedSort(next)
      sendEvent('issue_viewer.comments.sort_changed', {sort: next})
    },
    [savedSort, setSavedSort],
  )

  return {sort: enabled ? savedSort : ChronologicalCommentsSort.OldestFirst, setSort, enabled}
}
